<template>
  <section class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="myCenterCommon__users_layout__title__3CoQ0"><h3>活动申请记录</h3></div>
    <div class="myCenterCommon__users_layout__title__3CoQ0" style="padding-top: 30px"></div>
    <el-table :data="activityApplyLogList" style="width: 100%">
      <el-table-column prop="activity_name" label="活动标题"> </el-table-column>
      <el-table-column prop="created_at" label="申请时间"> </el-table-column>
      <el-table-column prop="state" label="状态" width="180">
        <template slot-scope="scope">
          {{ statuTypeS[scope.row.state] }}
        </template></el-table-column
      ></el-table
    >
  </section>
</template>

 
<script>
export default {
  name: 'mine',
  data() {
    return { activityApplyLogList: [], statuTypeS: ['0未约定', '待审核', '通过', '拒绝', '4未约定'] };
  },
  created() {
    let that = this;
    that.getactivityApplyLogList();
  },
  methods: {
    // 获取活动申请记录
    getactivityApplyLogList() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        limit: 999,
        page: 1,
      };
      that.$apiFun
        .post('/api/activityApplyLog', {})
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.activityApplyLogList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {});
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/activityRecord.vue